import { useStorage } from '@vueuse/core';

const developerMode = useStorage<boolean>('avp.devmode.v1', false);

if (typeof window !== 'undefined') {
  const params = new URLSearchParams(window.location.search);
  if (params.get('dev') === '1') developerMode.value = true;
  if (params.get('dev') === '0') developerMode.value = false;
}

export function useDeveloperMode() {
  return {
    enabled: developerMode,
    toggle() {
      developerMode.value = !developerMode.value;
    },
    set(value: boolean) {
      developerMode.value = value;
    },
  };
}
